import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';
//Toast Component
import { ToastComponent } from '../../../../common/toast.component';
//Const file 
import { checkoutFields, editOrders, states, toastMsg } from '../../../../utils';
//Service File 
import { EcommerceOrdersService } from '../../orders.service';

@Component({
  selector: 'app-order-edit',
  templateUrl: './order-edit.component.html',
  styleUrls: ['./order-edit.component.scss']
})
export class OrderEditComponent implements OnInit {
  orderDetails: any;
  nodeId: string;
  userId: string;
  editOrders = editOrders;
  checkoutFields = checkoutFields;
  states = states;
  toastMsg = toastMsg ; 
  orderInfoFormGroup: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    /** Service file */
    private ordersService: EcommerceOrdersService,
    /** MatDialog Ref */
    private dialogRef: MatDialogRef<OrderEditComponent>,
    /** Local component */
    public toastComponent: ToastComponent,
  ) { }

  ngOnInit() {
    this.userId = window.localStorage.getItem('userUID');
    this.nodeId = this.data.nodeId;
    this.orderDetails = JSON.parse(this.data.orderContent);
    this.orderInfoFormGroup = this.formBuilder.group({
      address: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      postcode: ['', Validators.required],
    });
    var buyerProperty = this.orderDetails
      ? _.find(this.orderDetails.meta_data, { key: checkoutFields.buyerProperty })
      : null; // Buyer property

    this.orderInfoFormGroup.controls['address'].setValue(buyerProperty ? buyerProperty.value : '');
    this.orderInfoFormGroup.controls['city'].setValue(this.orderDetails && this.orderDetails.billing && this.orderDetails.billing.city ? this.orderDetails.billing.city : '');
    this.orderInfoFormGroup.controls['state'].setValue(this.orderDetails && this.orderDetails.billing && this.orderDetails.billing.state ? this.orderDetails.billing.state : '');
    this.orderInfoFormGroup.controls['postcode'].setValue(this.orderDetails && this.orderDetails.billing && this.orderDetails.billing.postcode ? this.orderDetails.billing.postcode : '');
  }
  saveEdit() {
    this.orderDetails.meta_data.forEach((element, key) => {
      if (element.key == checkoutFields.buyerProperty) {
        this.orderDetails.meta_data[key].value = this.orderInfoFormGroup.getRawValue().address;
      }
    });
    this.orderDetails.billing.city = this.orderInfoFormGroup.getRawValue().city;
    this.orderDetails.billing.state = this.orderInfoFormGroup.getRawValue().state;
    this.orderDetails.billing.postcode = this.orderInfoFormGroup.getRawValue().postcode;
    let orderString = JSON.stringify(this.orderDetails);
    //Modal Response Sends to Order Table
    this.dialogRef.close(this.orderInfoFormGroup.getRawValue());
    //update order value in DB query Call 
    this.ordersService.editOrder(this.nodeId, this.userId, orderString).then((editRes) => {
      this.showToast('success');
    }).catch((err) => {
      this.showToast('failed');
      this.orderInfoFormGroup.getRawValue().city = '';
      this.orderInfoFormGroup.getRawValue().state = '';
      this.orderInfoFormGroup.getRawValue().postcode = '';
      this.orderInfoFormGroup.getRawValue().address = '';
      console.log("err in Edit ", err);
    });
  }
  //Show toast message
  showToast(message) {
    this.toastComponent.showToast(
      message == 'success'
        ? this.toastMsg.editSuccess
        : this.toastMsg.editFailed
    );
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-edit/order-edit.component.ts